import type { FeedbackResponse } from '@indeed/signals-schema/com/indeed/signals/schema/jspremium/Feedback';

import { ApplicantInsightsFeedbackContent } from './ApplicantInsightsFeedbackContent';
import { Text } from '../../../../../../mads/Text';
import { useI18n } from '../../../../../../shared/I18n';
import { SlideIn } from '../../../core/SlideIn';

import { colors } from '@indeed/ifl-tokens';
import React from 'react';

export type FeedbackPopupProps = {
    isOpen: boolean;
    onDismiss: () => void;
    feedbackResponse?: FeedbackResponse;
    feedbackText?: string;
};

export function FeedbackPopup({ isOpen, onDismiss }: FeedbackPopupProps) {
    const gt = useI18n();

    return (
        <SlideIn
            isOpen={isOpen}
            onDismiss={onDismiss}
            title={
                <Text level={3} sx={{ color: colors.foreground.strong }}>
                    {gt.gettext('How could we improve this feature?')}
                </Text>
            }
            sx={{ backgroundColor: colors.background['[base]'] }}
        >
            <ApplicantInsightsFeedbackContent />
        </SlideIn>
    );
}
